import { gql } from '@apollo/client';

export const MARK_NOTIFICATION_AS_READ = gql`
    mutation MarkNotificationAsRead($notificationId: Int!) {
        markNotificationAsRead(notificationId: $notificationId) {
            message {
                id
                priority
                message
                tenantId
                createdAt
            }
            userId
            roleId
            receivedAt
            readAt
            hide
            important
            module
            relatedCount
            pinned
            muted
        }
    }
`;

export const MARK_ALL_NOTIFICATIONS_AS_READ = gql`
    mutation MarkAllNotificationsAsRead {
        markAllNotificationsAsRead {
            success
            count
        }
    }
`;

export const TOGGLE_NOTIFICATION_PIN = gql`
    mutation ToggleNotificationPin($notificationId: Int!) {
        toggleNotificationPin(notificationId: $notificationId) {
            message {
                id
            }
            pinned
        }
    }
`;

export const TOGGLE_NOTIFICATION_MUTE = gql`
    mutation ToggleNotificationMute($notificationId: Int!) {
        toggleNotificationMute(notificationId: $notificationId) {
            message {
                id
            }
            muted
        }
    }
`;
